export default __webpack_public_path__ + "static/media/impact3.806984b1.webp";